import { Injectable } from '@angular/core';
import gql from 'graphql-tag';

import { SortDirection } from 'infrastructure/common/model/api.sort-direction';
import { UserNoteOutput } from 'user/model/user-note.output';
import { UserNoteSort } from 'user/model/user-note.sort';

import { ApiPageableOutput } from '../../../../common/model/api-pageable.output';
import { ApiQuery } from '../../../../common/model/api.query';

export interface SearchUserCoachNotesParams {
	readonly chunkSize: number;
	readonly note?: string;
	readonly offset: number;
	readonly targetId?: string;
	readonly startOfDayTimestamp?: number;
	readonly sortDirection?: SortDirection;
	readonly sortProperty: UserNoteSort;
	readonly endOfDayTimestamp?: number;
}

@Injectable({ providedIn: 'root' })
export class SearchUserCoachNotesApiQuery extends ApiQuery<
	ApiPageableOutput<UserNoteOutput>,
	SearchUserCoachNotesParams
> {
	client = 'iam';
	document = gql`
		query SearchUserCoachNotes(
			$chunkSize: Int
			$endOfDayTimestamp: Long
			$note: String
			$offset: Int
			$sortDirection: Direction
			$sortProperty: UserNoteSort
			$startOfDayTimestamp: Long
			$targetId: UUID!
		) {
			searchUserCoachNotes(
				chunkSize: $chunkSize
				endOfDayTimestamp: $endOfDayTimestamp
				note: $note
				offset: $offset
				sortDirection: $sortDirection
				sortProperty: $sortProperty
				startOfDayTimestamp: $startOfDayTimestamp
				targetId: $targetId
			) {
				elements {
					id
					note
					user {
						id
					}
					target {
						id
					}
					visibility
					creationTimestamp
				}
				totalElements
			}
		}
	`;
	method = 'searchUserCoachNotes';
}
